export default __webpack_public_path__ + "static/media/MicroBit.2a6d0a53.png";